import { useSelector } from 'react-redux';
import { getUser } from '../../../selectors/user';
import { useEffect, useState } from 'react';
import { useDeviceType } from '@cian/ui-kit/responsive';
import { trackClickShowPhone, trackShowBanner } from '../tracking';

export const useShowBanner = () => {
  const { userId } = useSelector(getUser);
  const deviceType = useDeviceType();
  const [isShowPhone, setIsShowPhone] = useState(false);

  useEffect(() => {
    trackShowBanner(deviceType, userId);
  }, [deviceType, userId]);

  const showPhone = () => {
    setIsShowPhone(true);
    trackClickShowPhone(deviceType, userId);
  };

  const trackCallLink = () => {
    trackClickShowPhone(deviceType, userId);
  };

  return { showPhone, trackCallLink, isShowPhone };
};
